var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObstacleMonster31X1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/obstacleMonster3-1x1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "obstacleMonster3-1x1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#87BC4B",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Monster_3",
    transform: "translate(-10.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0212891,9.84894629 C24.7628564,8.10336069 32.0483746,8.85604439 36.3424879,13.9646848 C43.6280061,2.38616748 59.5339167,9.51264081 38.5619173,17.1675942 C42.1644694,23.7175438 42.0036412,32.7337337 40.0737026,39.7961488 C53.6958525,44.1841347 48.420687,50.3337207 38.7066627,43.5755819 C37.3396229,47.1147967 35.8439205,50.7661134 33.720988,53.9209791 C37.0662149,52.5597427 45.1397914,50.2536479 43.997911,56.4032339 C43.1133558,57.7964995 41.6659019,58.2769359 40.1862823,58.3730232 C35.6991751,58.7253432 32.2092028,56.6274376 28.4779882,56.4672921 C28.767479,54.6416338 29.394709,52.7679318 30.5365893,50.8782152 C26.8536232,52.3995972 22.1574393,52.3515536 17.94374,51.3426371 C17.6060008,52.2554663 17.139599,52.6238009 16.8822738,52.9761209 C16.2550438,52.9921354 14.7754242,53.36047 13.5531297,53.8889501 C15.4669855,52.7198881 18.9247921,52.7519172 20.4365774,53.18431 C22.366516,53.7288046 23.267154,54.8658374 22.1735221,58.2769359 C17.1235161,59.9424487 12.4594979,58.3409941 8.80869736,57.3641067 C8.77653172,54.4814883 13.2314733,51.8711172 13.7461236,49.260746 C12.7007402,46.9546513 10.9798783,44.4243529 10.1757372,41.9741272 C8.31012989,43.7517419 6.44452259,45.8816766 4.1446791,47.1308113 C0.493878592,48.6361787 -1.50039129,45.8976912 1.36235096,43.0471019 C3.66219445,41.1733999 6.44452259,40.0203525 8.840863,38.3228105 C6.87875877,29.6749553 8.24579861,17.9202779 15.5634824,12.0909828 C13.6496267,9.86496084 9.27509919,2.14594927 12.6042433,0 C16.9305223,0.35232003 18.4583903,6.13357143 18.8122124,9.75285901",
    id: "outline-bkg",
    fill: "#87BC4B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Layer_11",
    transform: "translate(13.000000, 3.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.46808511,13.5957447 C0.574468085,15.0159574 0.39893617,26.0585106 5.93617021,22.212766 C9.92553191,19.3244681 5.90425532,9.07978723 2.92021277,15.8617021",
    id: "STROKE_ba44fb7f-99eb-4766-8b4a-89c6d84ed66a",
    strokeWidth: 0.79787234,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40425532,23.1861702 L1.38829787,23.2340426 C2.7287234,25.7712766 6.59042553,24.5585106 7.2287234,22.0851064",
    id: "STROKE_961fff18-9d3b-4f21-aad6-138da76422e0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5797872,13.7712766 C15.7819149,13.2606383 18.1276596,22.3882979 21.5904255,21.5904255 C24.8138298,20.9521277 23.393617,12.8617021 18.8138298,13.4361702 C18.7340426,13.5 18.7021277,13.5319149 18.6861702,13.5319149 L18.4946809,13.8031915",
    id: "STROKE_dbed2dd9-d342-42f8-83a8-4a0370dccff1",
    strokeWidth: 0.79787234,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3882979,22.1010638 C20.712766,23.856383 23.7925532,22.6276596 23.9680851,20.5691489",
    id: "STROKE_474d17ed-9804-4383-8f10-2f6935466565",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8297872,13.2446809 C16.7553191,12.2234043 17.9202128,11.712766 19.2765957,11.2021277 L19.2606383,11.2021277 L19.2446809,11.2180851",
    id: "STROKE_6e8d11ec-3a45-41d1-a16d-1358fd2b3b72",
    strokeWidth: 0.957446809
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30851064,11.537234 L4.32446809,11.5531915 L4.37234043,11.5212766 C5.74468085,11.7606383 7.13297872,12.3670213 8.07446809,13.4840426 L8.20212766,13.5159574",
    id: "STROKE_f9023376-ea85-4ae2-9c03-cf84443b9383",
    strokeWidth: 0.957446809
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58510638,16.7393617 C5.56914894,16.643617 5.58510638,16.4042553 5.5212766,16.7074468 C5.50531915,18.462766 6.62234043,16.5478723 5.79255319,16.037234 C5.61702128,16.037234 5.64893617,16.1010638 5.42553191,16.1648936 C5.40957447,16.1808511 5.34574468,16.2606383 5.21808511,16.4042553",
    id: "STROKE_b5b6b4e4-d006-4fcf-b525-fa5c7b980420",
    strokeWidth: 0.957446809
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.787234,15.8457447 C18.7659574,16.0851064 20.1542553,18.0319149 19.8989362,15.7659574 L19.8670213,15.8457447 C19.8670213,15.8776596 19.7553191,16.1968085 19.7393617,16.2446809",
    id: "STROKE_3ee235b0-eb21-4fcf-b03f-1423e6e787a1",
    strokeWidth: 0.957446809
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mouth",
    transform: "translate(0.000000, 24.414859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teeth",
    transform: "translate(1.684340, -0.000000)",
    strokeWidth: 0.957446809
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82629879,2.45748163 C3.31034135,3.00003482 4.39544773,4.46811992 5.48055411,5.50535397 L0.661405176,6.78194971 C0.278426452,5.45748163 0.422043474,3.14365184 1.82629879,2.45748163 Z M16.330747,5.49424958 L16.3827284,5.41454943 C18.8945199,1.70938141 20.2907832,1.08096771 20.8475754,6.47875822 L16.1401286,5.77663056 C16.1985341,5.68849773 16.2563647,5.60189022 16.3136236,5.51684215 L12.2305541,5.01067312 C12.1028945,3.43088588 12.3901286,1.3564178 13.3794903,0.0479071576 C14.7875645,-0.537472002 15.6780061,4.41424882 16.330747,5.49424958 Z",
    id: "shadow",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34757539,2.61705609 C2.83161794,3.15960929 3.91672432,4.62769439 5.00183071,5.66492843 L0.182681771,6.94152418 C-0.200296952,5.61705609 -0.0566799306,3.30322631 1.34757539,2.61705609 Z M15.8520236,5.65382405 L15.904005,5.57412389 C18.4157965,1.86895588 19.8120598,1.24054218 20.368852,6.63833269 L15.6614052,5.93620503 C15.7198107,5.8480722 15.7776413,5.76146469 15.8349002,5.67641662 L11.7518307,5.17024758 C11.6241711,3.59046035 11.9114052,1.51599226 12.9007669,0.207481626 C14.3088411,-0.377897534 15.1992827,4.57382329 15.8520236,5.65382405 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.18620503 C6.5106383,3.44684333 15.9255319,5.36173694 23.2180851,7.14897099",
    id: "shadow",
    strokeWidth: 0.957446809,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.50535397 C6.5106383,3.76599226 15.9255319,5.68088588 23.2180851,7.46811992",
    id: "STROKE_8a27d5a6-d73e-47d0-bcfc-57dcabb213d0_1_",
    strokeWidth: 0.957446809
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5212766,9.36705609 C9.68617021,7.97875822 14.7765957,8.44152418 18.9734043,9.54258801",
    id: "STROKE_e3e5c422-a60c-4f76-b022-c7a4c8fb2e6e",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#222222",
    strokeWidth: 0.03,
    x: 0.015,
    y: 0.015,
    width: 29.97,
    height: 29.97
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObstacleMonster31X1);
export default __webpack_public_path__ + "static/media/obstacleMonster3-1x1.f7ce9a20e48447f9c36e2542f852ca6a.svg";
export { ForwardRef as ReactComponent };